export default __webpack_public_path__ + "static/media/card-Visa_Inc._logo.1fae40ca.svg";